import React from 'react';
import { Box, Button, Card, CardActions, CardContent, Grid, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';
import type { IGeographical } from '../../interfaces';
import { Close } from '@mui/icons-material';

interface AreaListProps {
  readonly areas: IGeographical[];
  readonly onDelete?: (name: string) => void;
}

export default function AreaList({ areas, onDelete }: AreaListProps) {

  const geometricShape = (area: IGeographical) => {
    if (area.radius != undefined && area.point != undefined) {
      return 'circle'
    } else return 'rectangle'
  }

  return (
    <Stack
      direction="row"
      marginTop={2}
      sx={{
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 1
      }}
    >
      {!areas.length ?
        <Typography>
          Nenhuma área geográfica selecionada
        </Typography>
        : areas.map((area) => (
          <Paper key={area.id} elevation={0}>
            <Card>
              <CardContent
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  "&:last-child": {
                    paddingBottom: '16px',
                  }
                }}>
                <Stack direction="row" spacing={1} alignItems="center" flex={1}>
                  <Box sx={{ borderRadius: `${geometricShape(area) === 'circle' ? '50%' : '10%'}`, bgcolor: area.color, width: 30, height: 30 }} />
                  <Typography>{area.name}</Typography>
                </Stack>
                {onDelete && (
                  <Tooltip title="Remover">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(area.name);
                      }}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </CardContent>
            </Card>
          </Paper>
        ))

      }
    </Stack>
  )
}